import * as React from 'react';

function SvgStar(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M24 8.75h-8.04L12 0 7.98 8.75H0l6.55 6.37L4.58 24 12 19.29 19.42 24l-1.96-8.88L24 8.75zm-8.73 5.71l1.16 5.27L12 16.92l-4.42 2.8 1.17-5.26-3.82-3.7h4.33L12 4.81l2.68 5.93h4.4l-3.8 3.71z" />
    </svg>
  );
}

export default SvgStar;
